/**
 * Returns the array grouped by the poperties sent using Map
 * @param {Array} objectArray - The array to group.
 * @param {Array} properties - The string array of properties to group by.
 */
export default (objectArray, properties, separator = '|') =>
  objectArray.reduce((acc, obj, ix) => {
    // Index hack for node
    const key = properties.map((k) => obj[k]).join(separator);

    const group =
      acc.get(key) ||
      (() => {
        const arr = [];
        arr.ix = ix;

        return arr;
      })();
    group.push({ ...obj });

    acc.set(key, group);
    return acc;
  }, new Map());
